var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import { SliceLayout } from '../components/entities/slice-layout';
import { pickBy } from 'lodash';
import { classNames } from './cn';
export function createSliceLayout(Slice, options) {
  var _a = options || {},
      classNameId = _a.classNameId,
      _b = _a.props,
      props = _b === void 0 ? {} : _b,
      defaultBackgroundColor = _a.defaultBackgroundColor,
      defaultColor = _a.defaultColor,
      rest = __rest(_a, ["classNameId", "props", "defaultBackgroundColor", "defaultColor"]);

  var cls = classNameId && classNames(classNameId);
  return function (sliceLayoutProps) {
    var className = sliceLayoutProps.className,
        entity = sliceLayoutProps.entity;
    var layoutSlice = pickBy(__assign({
      backgroundColor: defaultBackgroundColor,
      color: defaultColor
    }, pickBy(entity)));
    return React.createElement(SliceLayout, __assign({}, rest, {
      entity: layoutSlice,
      className: cls ? cls.name(className) : className
    }), React.createElement(Slice, __assign({}, props, {
      entity: entity
    })));
  };
}
;